// extracted by mini-css-extract-plugin
module.exports = {"videoSection":"Amazon_videoSection__ce5WV","logo":"Amazon_logo__kNaS0","video":"Amazon_video__1Qqnp","button":"Amazon_button__nOnMl","text":"Amazon_text__gpmRK"};